import { isObservableArray } from 'mobx';


/* Active when either the current step.isActive evaluates to true or any one of our children */
function isStepActive(step) {
    if (step.isActive != null) {
        return typeof step.isActive === 'function' ? step.isActive() : step.isActive;
    }

    if (hasSubSteps(step)) {
        return step.steps.some(s => isStepActive(s));
    }

    return false;
}

/* Completed when either the current step.isCompleted evaluates to true or all chlidren are compelted */
function isStepCompleted(step) {
    if (step.isCompleted != null) {
        return typeof step.isCompleted === 'function' ? step.isCompleted() : step.isCompleted;
    }

    if (hasSubSteps(step)) {
        return step.steps.every(s => isStepCompleted(s));
    }

    return false;
}

/* Disabled when either the current step.isDisabled evaluates to true or all chlidren are disabled */
function isStepDisabled(step) {
    if (step.isDisabled != null) {
        return typeof step.isDisabled === 'function' ? step.isDisabled() : step.isDisabled;
    }

    if (hasSubSteps(step)) {
        return step.steps.every(s => isStepDisabled(s));
    }

    return false;
}

function hasSubSteps(step) {
    return Array.isArray(step.steps) || isObservableArray(step.steps);
}

function getActiveStep(steps) {
    for (let i = 0; i < steps.length; i++) {
        let step = steps[i];

        if (step.isActive != null) {
            if (isStepActive(step)) {
                return step;
            }
        }

        if (hasSubSteps(step)) {
            const activeStep = getActiveStep(step.steps);

            if (activeStep) {
                return activeStep;
            }
        }
    }
}

export default function getBreadcrumbStatus(step) {
    return {
        isActive: isStepActive(step),
        isCompleted: isStepCompleted(step),
        isDisabled: isStepDisabled(step),
    };
}

export {
    isStepActive,
    isStepCompleted,
    isStepDisabled,
    getActiveStep,
};